<template>
  <div class="smk-job-forms-main">
    <DesignerV2 :viewMode="true" :reportFile="designerV2ReportFile" reportFolder="ROTForm" :reportData="designerV2ReportData" :showBackground.sync="showBackground"/>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  components: {
  },
  computed: {
  },
  data: function () {
    return {
      designerV2ReportData: null, // initialised in mounted()
      designerV2ReportFile: [], // initialised in mounted()
      showBackground: true
    };
  },
  props: {
  },
  methods: {
  },
  async mounted() {
    this.$fullscreenLoading("Loading");
    this.designerV2ReportData = (await this.$apiCallV2(`/SMKJob/PrintSMKForm?userid=${this.$route.params["userID"]}&config=${this.$route.params["config"]}&temptbl=${this.$route.params["temptbl"]}&jobno=${this.$route.params["jobno"]}&baseSMK=${this.$route.params["base"]}&cocode=${this.$route.params["cocode"]}`))["smkform"]["TmpJobPrint"][0];

    if (this.designerV2ReportData.nparty_name) {
      this.designerV2ReportData._applicantName = this.designerV2ReportData.nparty_name;
      this.designerV2ReportData._applicantAddr1 = this.designerV2ReportData.nparty_addr1;
      this.designerV2ReportData._applicantAddr2 = this.designerV2ReportData.nparty_addr2;
      this.designerV2ReportData._applicantAddr3 = this.designerV2ReportData.nparty_addr3;
      this.designerV2ReportData._applicantAddr4 = this.designerV2ReportData.nparty_addr4;
      this.designerV2ReportData._applicantPostcode = this.designerV2ReportData.nparty_postcode;
      this.designerV2ReportData._applicantCity = this.designerV2ReportData.nparty_city;
      this.designerV2ReportData._applicantState = this.designerV2ReportData.nparty_state;
    } else {
      this.designerV2ReportData._applicantName = this.designerV2ReportData.exp_name;
      this.designerV2ReportData._applicantAddr1 = this.designerV2ReportData.exp_addr1;
      this.designerV2ReportData._applicantAddr2 = this.designerV2ReportData.exp_addr2;
      this.designerV2ReportData._applicantAddr3 = this.designerV2ReportData.exp_addr3;
      this.designerV2ReportData._applicantAddr4 = this.designerV2ReportData.exp_addr4;
      this.designerV2ReportData._applicantPostcode = this.designerV2ReportData.exp_postcode;
      this.designerV2ReportData._applicantCity = this.designerV2ReportData.exp_city;
      this.designerV2ReportData._applicantState = this.designerV2ReportData.exp_state;
    }

    this.designerV2ReportFile = [`SMK_${this.designerV2ReportData['jobformtype']}.json`];
    if (this.designerV2ReportData['ItemLongDesc'] != null){
      this.designerV2ReportFile.push(`SMK_${this.designerV2ReportData['jobformtype']}_Extra.json`)
    }
    this.$fullscreenLoading();
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '@/css/all.scss';
.smk-job-forms-main {
  height: 100%;
  width: 100%;
}
</style>